// https://w.amazon.com/index.php/ClientSideMetrics/UserDocs/Instrumentation/Tags
import { csmName } from './util';
import type { Placement } from '../placement';

/**
 * @description CSM - Add custom label you can associate with your hit on Placement level.
 * @param tagPrefix start of key to add to window.ue.tag
 * @param placement The Placement you want to log metrics for
 * @param tagSuffix end of key to add to window.ue.tag (optional)
 * @example addPlacementTag('adrender', {id: '597b923a-8c7e-4665-9541-de88160dd0ba', name: 'Gateway_right-2_desktop'})
 * @example addPlacementTag('adrender', {id: '597b923a-8c7e-4665-9541-de88160dd0ba', name: 'Gateway_right-2_desktop'}, 'suffix')
 */
export const addCsmPlacementTag = (tagPrefix: string, placement: Placement, tagSuffix?: string): void => {
    if (!isUeTagAvailable()) return;
    ueTag(placementTag(tagPrefix, placement.id, tagSuffix));
    ueTag(placementTag(tagPrefix, csmName(placement.name), tagSuffix));
};

/**
 * @description CSM - Add custom label you can associate with your hit on Market level.
 * @example addTag('adrender')
 * @param tagPrefix start of key to add to window.ue.tag
 * @param tagSuffix end of key to add to window.ue.tag (optional)
 */
export const addCsmTag = (tagPrefix: string, tagSuffix?: string): void => {
    if (!isUeTagAvailable()) return;
    ueTag(tagPrefix + getTagSuffix(tagSuffix));
};

export const isUeTagAvailable = () => typeof window?.ue?.tag === 'function';
export const ueTag = (tag: string) => window?.ue?.tag(tag);

const placementTag = (tagPrefix: string, placement: string, tagSuffix: string | undefined) =>
    `${tagPrefix}:${placement}${getTagSuffix(tagSuffix)}`;
const getTagSuffix = (tagSuffix: string | undefined) => (tagSuffix ? `:${tagSuffix}` : '');
